var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useDependency } from '#context';
export function useInvitationBaseUrl() {
    _react_refresh_temp_1();
    const clientBaseUrl = useDependency('CLIENT_BASE_URL');
    const urlForInviteLinkCreation = useMemo(() => {
        return new URL('/i', clientBaseUrl);
    }, [clientBaseUrl]);
    return urlForInviteLinkCreation;
}
_react_refresh_temp_1(useInvitationBaseUrl, "urWZrPgDgTTSJJx+i69G5X17ZJY=", false, () => [useDependency]);
